// import { getCurrentInstance } from '@vue/composition-api'
/**
 *
 * @param {key} words
 * @returns Returns translated text or the last word after split
 */
import i18n from '@/libs/i18n'
// import LanguageService from '@/api/client/language.service'

function keyWord(words) {
  // we use this method call to add missing keys to languageResources
  // const response = await LanguageService.createResource(words)
  if (typeof words === 'string') {
    return words.split('.').pop()
  }
  return '' // Change this to an appropriate default value.
}
const translation = {
  methods: {
    $tk(key) {
      // Check if key exists when we want to collect non translated keys
      return i18n.te(key) ? i18n.t(key) : keyWord(key)
    },
  },
}

export default translation
